@if (message) {
  <div
    class="post-message"
    [attr.data-testid]="TestIds.Message"
    [innerHTML]="message"
  ></div>
}
